const setPreferencesButton = document.querySelector('.js--cookie-button');

if (setPreferencesButton) {
    setPreferencesButton.addEventListener('click', () => {
        const checkedCookieInput = document.querySelector('.cookie-bar__options input[type=radio]:checked');
        pushCookieTypesToDataLayer(checkedCookieInput.dataset.gtmCookieTypes);
    });
}

const acceptAllButton = document.querySelector('.js--cookie-button-all');

if (acceptAllButton) {
    acceptAllButton.addEventListener('click', () => {
        pushCookieTypesToDataLayer(acceptAllButton.dataset.gtmCookieTypes);
    });
}

function pushCookieTypesToDataLayer(types) {
    if (!window.dataLayer) {
        return;
    }

    window.dataLayer.push({
        event: 'enableCookie',
        cookieTypes: types,
    });

    types.split(',').forEach((type) => {
        window.dataLayer.push({
            event: 'enableCookie',
            cookieType: type,
        });
    });
}

export { pushCookieTypesToDataLayer };
